// extracted by mini-css-extract-plugin
export var bottom = "AnimatedLine-module--bottom--d683b";
export var horizontal = "AnimatedLine-module--horizontal--84b49";
export var left = "AnimatedLine-module--left--0311b";
export var right = "AnimatedLine-module--right--984e9";
export var root = "AnimatedLine-module--root--9e8ad";
export var top = "AnimatedLine-module--top--5ae58";
export var vertical = "AnimatedLine-module--vertical--4a812";